import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import './accessStoreControl.css';

const ViewStoreModal = ({ store, onClose }) => {
  const [markerPosition, setMarkerPosition] = useState([parseFloat(store.latitude), parseFloat(store.longitude)]);

  return (
    <div>
      <div className="add-store-form-wrapper">
        <div className="input-row">
          <div className="add-store-input-group">
            <div className="slide1-section-title">Store Name:</div>
            <input
              className="add-business-input"
              type="text"
              value={store.name}
              disabled
            />
          </div>
          <div className="add-store-input-group">
            <div className="slide1-section-title">Google Review URL:</div>
            <input
              className="add-business-input"
              type="text"
              value={store.google_review_url}
              disabled
            />
          </div>
        </div>

        <div className="input-row">
          <div className="add-store-input-group">
            <div className="slide1-section-title">Latitude:</div>
            <input
              className="add-business-input"
              type="text"
              value={store.latitude}
              disabled
            />
          </div>
          <div className="add-store-input-group">
            <div className="slide1-section-title">Longitude:</div>
            <input
              className="add-business-input"
              type="text"
              value={store.longitude}
              disabled
            />
          </div>
        </div>

        <MapContainer
          center={markerPosition}
          zoom={13}
          scrollWheelZoom={false}
          dragging={false}
          doubleClickZoom={false}
          zoomControl={false}
          style={{ height: '300px', width: '100%', marginBottom: '1em' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={markerPosition} draggable={false} />
        </MapContainer>

        <div className="add-business-btns-container">
          <button className="btn btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ViewStoreModal;
